export default {
  QuoteSmsIncoming: 1,
  QuoteEmailIncoming: 2,
  CompanyLicense: 3,
  QuoteWhatsAppIncoming: 4,
  QuoteImageUploadedIncoming: 5,
  QuoteCreated: 6,
  QuoteImageUploadedByUser: 7
}